export default __webpack_public_path__ + "static/media/il.7e01155c.svg";